import React, { useEffect, useState } from "react";
import { Modal, Row, Col, Container, Button, Form, Spinner } from 'react-bootstrap';
import { Formik } from 'formik';
import { useAppSelector, useAppDispatch } from "../../../../store/hooks";
import {
    getAMaterialRequestAsync, setMaterialRequestId, reviewMaterialRequestAsync, getAllMaterialRequestsAsync
} from '../../../../slices/requests/requestsSlice';
import { RootState } from "../../../../store/store";
import { toast } from "react-toastify";

interface RejectMaterialRequestValues {
    company_id: string;
    projectId: string;
    id: string;
    action: string;
    status: string;
}

interface RejectMaterialRequestProps {
    closeModal: () => void;
    show: boolean;
    materialRequestId: string;
    projectId: string;
}

const RejectMaterialRequest: React.FC<RejectMaterialRequestProps> = ({ closeModal, show, materialRequestId, projectId }) => {
    const dispatch = useAppDispatch();
    const companyId = useAppSelector(
        (state: RootState) => state.auth.user?.company_id || "",
    );
    const materialRequestData = useAppSelector((state: any) => state.requests.materialRequestData);
    const [loading, setLoading] = useState(true);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [pageNumber, setPage] = useState(1);

    useEffect(() => {
        if (materialRequestId) {
            dispatch(setMaterialRequestId(materialRequestId));
            console.log("Fetching material request with ID:", materialRequestId);
            dispatch(getAMaterialRequestAsync({ companyId, id: materialRequestId, projectId })).then(() =>
                setLoading(false),
            );
        } else {
            console.log("materialRequestId is not set");
        }
    }, [dispatch, companyId, materialRequestId, projectId]);

    if (loading) {
        return null;
    }
    console.log("materialRequestData", materialRequestData);
    return (
        <Container>
            <Modal className="confirm-modal" size="lg" show={show} onHide={closeModal} style={{ maxHeight: "100vh", overflowY: "auto", maxWidth: "90vh" }}>
                <div className='px-4 '>
                    <Formik
                        initialValues={{
                            company_id: companyId || "",
                            projectId: projectId || '',
                            id: materialRequestData?.material_requests?.id || '',
                            action: 'approve/reject',
                            status: 'rejected',
                        }}
                        onSubmit={(values: RejectMaterialRequestValues, { setSubmitting }) => {
                            console.log(values);
                            const addSpacesToMessage = (message: any) => {
                                return message.replace(/([a-z])([A-Z])/g, '$1 $2');
                            };
                            dispatch(
                                reviewMaterialRequestAsync({
                                    ...values,
                                }),
                            ).unwrap()
                                .then((response: any) => {
                                    toast.success("Material request rejected successfully");
                                    dispatch(getAllMaterialRequestsAsync({ companyId, projectId, page: pageNumber }));
                                    closeModal();
                                })
                                .catch((error) => {
                                    const errorMessage = error.message.original.message ? addSpacesToMessage(error.message.original.message) : "An unexpected error occurred";
                                    toast.error(errorMessage);
                                })
                                .finally(() => {
                                    setSubmitting(false);
                                });
                        }}
                    >
                        {({ handleSubmit, isSubmitting }) => (
                            <Form onSubmit={handleSubmit}>
                                <Modal.Header closeButton className='text-start'>
                                    <h4 className="confirm-header">Reject material request</h4>
                                </Modal.Header>
                                <Modal.Body>
                                    <p className="confirm-body">Are you sure want to reject this request?</p>
                                </Modal.Body>
                                <Modal.Footer className='mt-2'>
                                    <Row >
                                        <Col md={6}>
                                            <div className=' mt-1'>
                                                <Button onClick={closeModal} className='cancel-btn'>
                                                    <span className="text-center">No </span>                                        </Button>
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className=' mt-1'>
                                                <Button type='submit' className=' border-0 create-btn bg-color-1'>
                                                    {isSubmitting ? (
                                                        <Spinner animation="border" size="sm" />
                                                    ) : (
                                                        <span className="text-center"> Yes</span>
                                                    )}
                                                </Button>
                                            </div>
                                        </Col>
                                    </Row>
                                </Modal.Footer>
                            </Form>
                        )}
                    </Formik>
                </div>
            </Modal>
        </Container>
    )
}

export default RejectMaterialRequest;